import React from 'react';

import {
  Breadcrumb,
  Helmet,
  Sidebar,
  SidebarPage,
  SidebarPageContainer,
} from 'fr-shared/components';
import { useTableFilters } from 'fr-shared/hooks';

import CostingSearch from './components/CostingSearch';
import CostingSidebar from './components/CostingSidebar';
import CostingTable from './components/CostingTable';
import {
  DRAFT_COLUMNS,
  FILTER_FIELDS,
  INITIAL_DRAFT_FILTERS,
  INITIAL_DRAFT_SORT,
  getDraftCostingRequest,
} from './utils/queues';

const FILTER_NAME = 'costing_draft';
const FIELDS = [
  FILTER_FIELDS.SalesContactId,
  FILTER_FIELDS.ManufacturingProcessId,
  FILTER_FIELDS.EngineeringContactId,
  FILTER_FIELDS.SupportContactId,
];

const CostingDraftQueue = () => {
  const {
    data: costingRequests,
    filters,
    loading,
    handleSearch: handleTextSearch,
    onFetchData: handleTableFetchData,
    pages,
    resetFilters,
    setFilters,
  } = useTableFilters(FILTER_NAME, INITIAL_DRAFT_FILTERS, getDraftCostingRequest);

  return (
    <>
      <Helmet title="Draft Queue" />
      <Breadcrumb to="/admin/costing_requests">Costing Requests</Breadcrumb>
      <Breadcrumb to="/admin/costing_requests/draft_queue">Draft Queue</Breadcrumb>

      <SidebarPageContainer localStorageKey={Sidebar.LOCAL_STORAGE_KEYS.costing_draft}>
        <SidebarPage>
          <div className="page-header flex mb-0 px-3">
            <h2>Draft Queue</h2>
            <CostingSearch
              filters={filters}
              setFilters={setFilters}
              onTextSearch={handleTextSearch}
            />
          </div>

          <CostingTable
            columns={DRAFT_COLUMNS}
            data={costingRequests}
            emptyText="No Requests are currently drafted"
            loading={loading}
            onFetchData={handleTableFetchData}
            pages={pages}
            sort={INITIAL_DRAFT_SORT}
          />
        </SidebarPage>

        <Sidebar>
          <CostingSidebar
            fields={FIELDS}
            filters={filters}
            resetFilters={resetFilters}
            setFilters={setFilters}
          />
        </Sidebar>
      </SidebarPageContainer>
    </>
  );
};

export default CostingDraftQueue;
